<template>
    <div class="lm-border pa-3" v-if="data">
        <div class="v-flex step-title ">
            <div class=" primary--text" style="padding-top: 3px;">
                <span>{{ collective ? "Rechnungsposten für Anlage " + unit.fabricNo : "Rechnung" }}</span>
            </div>
            <p-inc-invoice-stamp-menu
                v-if="!collective"
                :data    = "data"
                :unit-id = data.unit.id
                @stamped = "onStamped"
                @mail    = "onSendStampMail"
                @reset   = "onReset"
                style="margin-bottom: 3px;"
            />
        </div>

        <!-- Invoice dates -->
        <p-inc-invoice-dates
            v-if="!collective"
            :data = "data"
            :collective = "false"

        />
        <!-- Invoice dates -->

        <!-- Invoice number and invoice date -->
        <v-row class="no-frame mt-0" v-if="!collective">
            <v-col class="no-frame mr-2">
                <v-text-field
                    v-model        = "data.invoicenumber"
                    :rules         = "[requiredOnTerminationRule]"
                    :label         = "$t('invoice.invoicenumber')"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
            <v-col class="no-frame ml-2">
                <f-date-picker
                    v-model = "data.invoiceDate"
                    label   = "invoice.invoiceDate"
                    :time   = "false"
                />

            </v-col>
        </v-row>
        <!-- Invoice number and invoice date -->

        <slot name="required"></slot>
        <v-row
            v-if="showCosts"
            class = "no-frame mt-0"
        >
            <v-col
                class  = "no-frame col-6 pr-1 pl-0 primary--text"
                style="font-size: 12px; text-align: center"
            >
                Urspungsrechnung
            </v-col>
            <v-col
                class="no-frame col-6 pl-2 primary--text"
                style="font-size: 12px; text-align: center"
            >
                Korrigierte Rechnung
            </v-col>
        </v-row>

        <v-row
            class = "no-frame mt-0"
        >
            <v-col class = "no-frame col-6 pr-2">
                <p-inc-invoice-amount
                    :class           = "showCosts ? 'lm-border pl-2 pr-2' : ''"
                    :label           = "showCosts ? 'Betrag' : $t('invoice.cost.net')"
                    :status          = "data.status"
                    :item            = "data.item_1"
                    :amount          = "data.item_1.amount"
                    :calculation     = "calculation"
                    :show-costs      = "showCosts"
                    :form            = "form"
                    :validate-amount = "validate"
                />
            </v-col>
            <v-col class="no-frame col-6 pl-2">
                <p-inc-invoice-amount
                    v-if             = "!bid"
                    :class           = "showCosts ? 'lm-border pl-2 pr-2' : ''"
                    :label           = "showCosts ? 'Betrag' : $t('invoice.cost.correction')"
                    :status          = "data.status"
                    :item            = "data.item_1"
                    :amount          = "data.item_1.correction"
                    :show-costs      = "showCosts && !bid"
                    :form            = "form"
                    :accept-spacer   = "bid !== null"
                    :validate-amount = "false"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                 from "@/modules/core/service/Core";
import FDatePicker          from "@/modules/core/components/utils/FDatePicker.vue";
import PIncInvoiceAmount    from "@/modules/inc/steps/components/invoice/private/PIncInvoiceAmount.vue";
import PIncInvoiceDates     from "@/modules/inc/steps/components/invoice/private/PIncInvoiceDates.vue";
import PIncInvoiceStampMenu from "@/modules/inc/steps/components/invoice/private/PIncInvoiceStampMenu.vue";

export default {
    name: "PIncInvoiceData",

    components: {
        PIncInvoiceDates,
        PIncInvoiceStampMenu,
        PIncInvoiceAmount,
        FDatePicker
    },

    props: {
        data: {
            required: false,
            type    : Object,
            default: function () {
                return {
                    invoiceDate: null,
                    invoicenumber: null,
                    item_1: {
                        acceptDifference: false,
                        amount          : null,
                        correction      : null,
                        calculated      : null,
                    },
                    item_2: {
                        acceptDifference: false,
                        amount          : null,
                        correction      : null,
                        calculated      : null,
                    },
                }
            }
        },

        form: {
            required: true,
            type    : Object,
        },

        bid: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        unit: {

        },

        showCosts: {
            required: true,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        calculation: {
            required: false,
            type    : Function,
            default : function () {
                return null;
            }
        },

        collective: {
            required: true,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        validate: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
     },

    data: () => ({
        documents : null,
        menu: false
    }),

    computed: {
        verificationDate () {
            return Core.format.date.display(this.data.verficationDate);
        }
    },

    methods: {
        /**
         * Open the mail dialog.
         */
        onSendStampMail (documents) {
            this.$emit("stampmail", documents);
        },

        /**
         * The selected document was stamped.
         */
        onStamped () {
            this.data.verficationDate = Core.format.date.toJson(Core.format.today());
            this.$emit("stamped");
        },

        onReset () {
            this.data.verficationDate = null;
            this.data.sendDate        = null;
            this.$emit("reset");
        },

        /**
         * Loads the documents assigned to the current processing step.
         */
        requiredOnTerminationRule (value)  {
            return Core.rule.requiredOnTermination(value, this.data.status);
        },
    }
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}

</style>